import { mopraLegend } from '../config/legends'

const service =  {
name: 'WellsiteReclamationSimple',
    label: 'Wellsite Reclamation',
    authId: 'ReclaimedWellsites',
      permissionId: 'ReclaimedWellsites',
      upload: false,
    description: '',
      iconComponent: 'Mopra',
      multiselect: false,
  autocomplete: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
  data: [
    {
      id: 'ReclaimedWellsitesSimple',
      url: `https://geoserver.looknorthservices.com/geoserver/coresight2/ows?version=1.0.0&maxFeatures=2900&outputFormat=application%2Fjson&service=WFS&request=GetFeature&typeName=coresight2%3AWellsiteRankPointData`,
      datetimeId: 'WellsiteEviControl',
      type: 'point'
    }
    ],
    datetimeUrls: [
      {
        id: 'Mopra',
        url:
          'https://geoserver.looknorthservices.com/geoserver/coresight2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=coresight2:ReclaimedWellsitesAreaBounds&maxFeatures=500&outputFormat=application%2Fjson'
      }
    ],
  layers: [
    {
      name: 'Vegetation',
      type: 'group',
      group: true,
      datetimeId: 'WellsiteEviControl',
      legend: {
        type: 'categorical',
        data: mopraLegend
      },
      filter: {
        min: 0,
        max: 300,
        value: 200,
        label: ' \u03C3 outlier',
        title: 'Outliers',
        transformLabel: ' \u03C3',
        transform: value => value/100,
        transformIn: value => value*100,
        transformOut: value => value/100
      },
      layers: [
        {
          name: 'WellsiteNdviLeaseSimple',
          label: 'NDVI lease',
          opacity: 'raster-opacity',
          datetimeId: 'WellsiteNdviLease'
        },
        {
          name: 'WellsiteNdviControlSimple',
          label: 'NDVI control',
          opacity: 'raster-opacity',
          datetimeId: 'WellsiteNdviLease'
        },
        {
          name: 'WellsiteEviLeaseSimple',
          label: 'EVI lease',
          opacity: 'raster-opacity',
          datetimeId: 'WellsiteEviLease'
        },
        {
          name: 'WellsiteEviControlSimple',
          label: 'EVI control',
          opacity: 'raster-opacity',
          datetimeId: 'WellsiteEviControl'
        }
      ]
    },
    {
      name: 'WellsiteNdviLeaseSimple',
      label: 'NDVI lease',
      opacity: 'raster-opacity',
      datetimeId: 'WellsiteNdviLease',
      hidden: true
    },
    {
      name: 'WellsiteNdviControlSimple',
      label: 'NDVI control',
      opacity: 'raster-opacity',
      datetimeId: 'WellsiteNdviLease',
      hidden: true
    },
    {
      name: 'WellsiteEviLeaseSimple',
      label: 'EVI lease',
      opacity: 'raster-opacity',
      datetimeId: 'WellsiteNdviLease',
      hidden: true
    },
    {
      name: 'WellsiteEviControlSimple',
      label: 'EVI control',
      opacity: 'raster-opacity',
      datetimeId: 'WellsiteNdviLease',
      hidden: true
    },
    {
      name: 'WellsiteNdviLeaseSimple',
      label: 'NDVI lease',
      opacity: 'raster-opacity',
      datetimeId: 'WellsiteNdviLease',
      hidden: true
    },
    {
      name: 'WellsiteNdviControl',
      label: 'NDVI control',
      opacity: 'raster-opacity',
      datetimeId: 'WellsiteNdviLease',
      hidden: true
    },
    {
      name: 'WellsiteEviLease',
      label: 'EVI lease',
      opacity: 'raster-opacity',
      datetimeId: 'WellsiteNdviLease',
      hidden: true
    },
    {
      name: 'WellsiteEviControl',
      label: 'EVI control',
      opacity: 'raster-opacity',
      datetimeId: 'WellsiteNdviLease',
      hidden: true
    },
      {
        name: 'MopraWellsites',
        label: 'Health',
        opacity: 'fill-opacity',
        datetimeId: 'MopraWellsites'
      },
      {
        name: 'WellsiteRank',
        label: 'Wellsite outliers',
        opacity: 'fill-opacity',
        hidden: true,
        open: true,
        datetimeId: 'WellsiteRank',
        filter: {
          min: 0,
          max: 300,
          value: 200,
          label: ' \u03C3 outlier',
          title: '',
          transform: value => value/100,
          transformIn: value => value*100,
          transformOut: value => value/100
        }
      },
      {
        name: 'Sentinel2NdviSimple',
        label: 'Sentinel 2 (10 m)',
        opacity: 'raster-opacity',
        // datetimeId: 'Sentinel2Ndvi',
        datetimeId: 'WellsiteEviControl',
        // secondary: true
      },
      {
        name: 'LandCover2010',
        label: 'ABMI Human Footprint',
        opacity: 'fill-opacity'
      }
    ],
      locations: [
      {
        name: 'BrooksAirport',
        label: 'Brooks Airport',
        latitude: 50.6207,
        longitude: -111.9190,
        // maxBounds: [[-112.5, 50], [-110.5, 51]],
        zoom: [17]
      },
      {
        name: 'LakeNewell',
        label: 'Lake Newell',
        latitude: 50.49,
        longitude: -111.993,
        // maxBounds: [[-112.5, 50], [-110.5, 51]],
        zoom: [15]
      }
    ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/ReclaimedWellsitesSimple.js